import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { StaffData } from '@interfaces';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<StaffData & { updatedUTC: number }, unknown>[] = [
		buildColumn(util, 'Id', row => row.staffId),
		buildColumn(util, 'Text', row => row.fullName, { header: 'Name' }),
		buildColumn(util, 'Email', row => row.email, { header: 'Email' }),
		buildColumn(util, 'Text', row => row.department, { header: 'Department' }),
		buildColumn(util, 'Status', row => row.status),
	];


	return columns;

}